import { getUrlParam } from '../utils/getValue';

const lang = getUrlParam('language') || localStorage.getItem('language') || 'zh-cn';
const titles_cn = {
  '/search': '服务网络列表',
  '/airport': '服务网络列表',
  '/cip/networkDetail': '服务网络列表',
  '/cip': '快速安检',
  '/cip/recordList': '快速安检',
  '/home': '使用休息室',
  '/record': '使用记录',
  '/use': '使用休息室',
};
const titles_en = {};

const titles = {
  'zh-cn': titles_cn,
  en: titles_en,
};

export default titles[lang] || titles['zh-cn'];
